import ForumGroup from './ForumGroup';

export default ForumGroup;
